import { FolderOperationalReportPageStore } from './folder-operational-report-page.store';
import { fb, routeParams, router } from '../../../../modules/shared/shared.global-service';
import { Component, computed, inject, viewChild } from '@angular/core';
import { PrimeTemplate } from '@openng/optimus-ui/api';
import { TranslatePipe } from '@ngx-translate/core';
import { dateFromColumn, descriptionColumn } from '../../../../modules/shared/components/kit/table/table.fields';
import { WorkTypeEnum } from '@libs/types/src/common/enum/work-type.enum';
import { contentGlobalSuccess } from '../../../../modules/content/content.error';
import { ConfirmBuilder } from '../../../../modules/shared/service/confirm.builder';
import { TableComponent } from '../../../../modules/shared/components/kit/table/table.component';
import { FilterBuilder } from '../../../../modules/content/helper/filter.builder';
import { getWorksFrag } from './folder-operational-report-page.query';
import { FilterInput } from '@it2go/data-grid';
import { workUri } from '../../../../utils/router.utils';
import { UserChipComponent } from '../../../kit/user-chip/user-chip.component';
import { ButtonComponent } from '../../../kit/button/button.component';
import { WorkPrintService } from '../../../medical-service/work/work-print.service';
import { WorkGridItemObject } from '@it2go/types';
import { WorkExportScopeEnum } from '@libs/types/src/services/enum/work-export.enum';
import { featureOn } from '../../../../feature-flag';

@Component({
    selector: 'app-folder-operational-report-page',
    templateUrl: './folder-operational-report-page.component.html',
    styleUrl: './folder-operational-report-page.component.scss',
    providers: [FolderOperationalReportPageStore],
    imports: [
        PrimeTemplate,
        TranslatePipe,
        TableComponent,
        UserChipComponent,
        ButtonComponent,
    ],
})
export class FolderOperationalReportPageComponent {

    public readonly store = inject(FolderOperationalReportPageStore);
    public readonly confirmBuilder = inject(ConfirmBuilder);
    protected readonly workPrint = inject(WorkPrintService);
    protected readonly extendedWorkExportsEnabled = featureOn.EXTENDED_WORK_EXPORTS;

    public readonly reportsTable = viewChild(TableComponent);

    protected form = fb.group({});

    protected columns = [
        dateFromColumn,
        { name: 'form', dataKey: 'workData.form' },
        { name: 'shift', dataKey: 'workData.shift' },
        { name: 'type', dataKey: 'workData.type' },
        {
            ...descriptionColumn,
            dataKey: 'workData.description',
        },
        { name: 'priority', dataKey: 'workData.priority' },
        {
            name: 'location',
            data: (item: any) => item.name,
        },
        {
            name: 'users',
            dataKey: 'workData.users',
        },
    ];

    protected filteredColumns = computed(() => {
        const settings = this.store.operationalSettings();

        return this.columns.filter(column => {
            if (column.name === 'shift' && !settings.useShift) return false;
            if (column.name === 'form' && !settings.useForm) return false;
            if (column.name === 'location' && !settings.useLocation) return false;
            return true;
        });
    });

    protected additionalFilters = computed<FilterInput[][]>(() => {
        return FilterBuilder.filter({
            workType: WorkTypeEnum.OPERATIONAL_REPORT,
            operationalFolderId: routeParams.folderId(),
        }).filter || [];
    });

    protected async goTo(item?: any): Promise<void> {
        await router.navigateByUrl(workUri({
            workType: WorkTypeEnum.OPERATIONAL_REPORT,
            id: item?.id,
        }, this.store.globalGlobalStore.loggedUserStore.selectedServiceId()));
    }

    protected deleteReport(event: any): void {
        this.confirmBuilder.confirmDelete(
            async () => {
                await this.store.api.deleteWork({ id: event.item.id });
                contentGlobalSuccess.next('common.deleted');
                this.reportsTable()?.reload();
            },
            event,
        );
    }

    protected readonly getWorksFrag = getWorksFrag;

    protected printRecords(): void {
        this.workPrint.openBulk({
            selection: this.reportsTable()?.selection(),
            supportedWorkTypes: [WorkTypeEnum.OPERATIONAL_REPORT],
            dateFrom: null,
            dateTo: null,
            folderIds: [Number(routeParams.folderId())],
        });
    }

    protected printRecord(item: WorkGridItemObject): void {
        this.workPrint.openRow(item, {
            folderIds: [Number(routeParams.folderId())],
            scope: WorkExportScopeEnum.FOLDERS,
        });
    }
}
